import { Action } from 'react-fetching-library';

export const getPageTranslationList: Action = {
  method: 'GET',
  endpoint: 'items/pages_translation',
};
